import { FunnelId } from '../types/funnel-interface'

export const getFunnelUrl = (funnelId: FunnelId) => `/funnels/${funnelId}`
